import { Injectable } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CartItem } from 'src/app/modals/cart-item';
import { map } from 'rxjs/operators';
import { Observable, BehaviorSubject, Subscriber } from 'rxjs';
import swal from 'sweetalert2';
import { MatSidenav } from '@angular/material';
import { Router } from '@angular/router';
import { ProductService } from './product.service';

// Get product from Localstorage
let products = JSON.parse(localStorage.getItem("cartItem")) || [];

// let remenber_id_order = JSON.parse(localStorage.getItem("remenberIdOrder")) || null;


@Injectable({
  providedIn: 'root'
})
export class CartService {

// Array
public cartItems  :  BehaviorSubject<CartItem[]> = new BehaviorSubject([]);
public observer   :  Subscriber<{}>;

// id du demarcheur ou de l'affilié du lien d'entree sur le site
idaffilate

public sideNavShopping: MatSidenav;

  constructor(public snackBar: MatSnackBar, public router: Router, public productService: ProductService) {
    this.cartItems.subscribe(
      products => products = products
    );

    // remenber_id_order = ''
  
   }

    // Get Products
  public getItems(): Observable<CartItem[]> {
    const itemsStream = new Observable(observer => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<CartItem[]>>itemsStream;
  }

   // Add to cart
   public addToCart(product: Product, quantity: number) {
    let message, status;
     var item: CartItem | boolean = false;
     // If Products exist
     let hasItem = products.find((items, index) => {
       if(items.product.id == product.id) {

          /* message = product.name + ' déjà ajouté dans votre panier.';
          status = 'success';
          this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 }); */ 


          // on met à jour
          item = { product: product, quantity: quantity, affiliate: this.idaffilate };
          products[index] = item;
          localStorage.setItem('cartItem', JSON.stringify(products));
          message = '(' + quantity + ')  ' + product.name + ' ajouté(s) dans votre panier.';
          status = 'success';
          this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 }); 
          return true;

          /* swal({
            title: 'Confirmation',
            html: message,
            // icon: 'warning',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            cancelButtonText: 'Continuer vos achats',
            confirmButtonText: 'Commander',
            // showLoaderOnConfirm: true,
            allowOutsideClick: false,
          }).then((result) => {

            if (result.value) {

              this.router.navigate(['/pages/checkout']);
              this.productService.closePopupEvent.next('close');

            }

            // this.dialogIsNotShow = false;

          }); */

         

       }
     });

     // If Products does not exist (Add New Products)

     if(!hasItem) {

      
      item = { product: product, quantity: quantity, affiliate: this.idaffilate };

      products.push(item);
      message = '(' + quantity + ')  ' + product.name + ' ajouté(s) dans votre panier.';

      status = 'success';
      this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 }); 

        /* swal({
          title: 'Confirmation',
          html: message,
          // icon: 'warning',
          type: 'success',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Continuer vos achats',
          confirmButtonText: 'Commander',
          // showLoaderOnConfirm: true,
          allowOutsideClick: false,
        }).then((result) => {

          if (result.value) {

            this.router.navigate(['/pages/checkout']);
            this.productService.closePopupEvent.next('close');

        }

        // this.dialogIsNotShow = false;

        }); */

      // affichage aperçu panier
      // this.sideNavShopping.open();
     }

     localStorage.setItem('cartItem', JSON.stringify(products));
     return item;

   }


   // clean

  public clean() {
    // products = [];
    while(products.length > 0) {

      for( let i = 0; i < products.length; i++){
        products.splice(i, 1);
      }

    }

    localStorage.setItem('cartItem', JSON.stringify(products));

  }

// Calculate Product stock Counts
public calculateStockCounts(product: CartItem, quantity): CartItem | Boolean {
  let message, status;
  let qty   = product.quantity + quantity;
  let stock = product.product.stock;
  if(stock < qty) {
    // this.toastrService.error('You can not add more items than available. In stock '+ stock +' items.');
    this.snackBar.open('You can not choose more items than available. In stock ' + stock + ' items.', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
    return false
  }
  return true
}





// Removed in cart
public removeFromCart(item: CartItem) {
  if (item === undefined) return false;
    const index = products.indexOf(item);
    products.splice(index, 1);
    localStorage.setItem("cartItem", JSON.stringify(products));
}

// Total amount
public getTotalAmount(): Observable<number> {
  return this.cartItems.pipe(map((product: CartItem[]) => {
    return products.reduce((prev, curr: CartItem) => {
      if(curr.product.salePrice === null || curr.product.salePrice === undefined)
      return prev + curr.product.price * curr.quantity;
      else
      return prev + curr.product.salePrice * curr.quantity;
    }, 0);
  }));
}

// Update Cart Value
public updateCartQuantity(product: Product, quantity: number): CartItem | boolean {
  return products.find((items, index) => {
    if(items.product.id == product.id) {
      let qty = products[index].quantity + quantity;
      let stock = this.calculateStockCounts(products[index], quantity);
      if (qty != 0 && stock)
        products[index]['quantity'] = qty;
      localStorage.setItem("cartItem", JSON.stringify(products));
      return true;
    }
  });
}


}
